/** 
 * e.g. useEmblaCarousel({..., align: alignSliderInContainer})
 */
export const alignSliderInContainer = (viewSize: number) => {
  if (viewSize > 1624) {
    const offset = (viewSize - 1624) / 2;
    return offset;
  } else if (viewSize > 1440) {
    const offset = (viewSize - 1344) / 2;
    return offset;
  }
  return 0;
};
